import { combineReducers } from 'redux'

import list from './list/slice'

const mentorsReducer = combineReducers({
  list,
})

export default mentorsReducer
